import { render } from "./Cancel.svg?vue&type=template&id=2cbbc566"
const script = {}
script.render = render

export default script